export default __webpack_public_path__ + "static/media/extension-01.51b2238d.png";